<template><!-- svgo-optimised -->
<svg class="icon icon__chevron icon__chevron--down" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m11.982 14.32-6.16-6.284-.822.84L11.982 16 19 8.84 18.177 8l-6.194 6.32Z" fill="currentColor"/></svg>
</template>